export default {

    orders:{
        orderInformation:"订单信息",
        theAmountToBePaid:"支付金额",
        orderNumber:"订单号",
        tipstitle:"温馨提示",
        remainingPaymentTime:"剩余支付时间",
        copy:"复制",
        theReplicationIsSuccessful:"复制成功",
        tips:{
            first:"1.订单过期后请勿支付，否则将不入账不退款。",
            second:"2.区块链转帐需等待一定数量的区块确认后才会到帐，请耐心等待。",
            third:"3.请留意您发起提币的平台是否有收取手续费，这将影响您的实际到帐金额。",
            fourth:"4.请务必确认电脑及浏览器安全，防止消息被篡改或泄露。",
        }
    }

}
